import React from "react";
import Input from "./Input";
import Select from "./Select";
import Submit from "./Submit";
import TextArea from "./TextArea";
import classNames from "classnames";

function Form({ className, children, id }) {
  return (
    <form
      className={classNames("form block-view", { [className]: !!className })}
      id={id}
    >
      {children}
    </form>
  );
}

Form.Input = Input;
Form.Select = Select;
Form.TextArea = TextArea;
Form.Submit = Submit;

export default Form;
